import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-cda1ae0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 col-xxl-12 col-sm-12 mb-10" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 mb-4" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1 position-relative top-2" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "position-relative" }, "Retour", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mb-0" }, "Détails de l'emploi du temps", -1))
const _hoisted_9 = { class: "row mb-4" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "info-card p-3 border rounded bg-light" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-primary mb-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-calendar me-2" }),
  /*#__PURE__*/_createTextVNode("Informations générales ")
], -1))
const _hoisted_13 = { class: "row mb-2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Type d'emploi:")
], -1))
const _hoisted_15 = { class: "col-7" }
const _hoisted_16 = { class: "row mb-2" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Date de début:")
], -1))
const _hoisted_18 = { class: "col-7" }
const _hoisted_19 = { class: "row mb-2" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Date de fin:")
], -1))
const _hoisted_21 = { class: "col-7" }
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = { class: "info-card p-3 border rounded bg-light" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-primary mb-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-clock me-2" }),
  /*#__PURE__*/_createTextVNode("Informations sur cours ")
], -1))
const _hoisted_25 = { class: "row mb-2" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Nombre de cours:")
], -1))
const _hoisted_27 = { class: "col-7" }
const _hoisted_28 = { class: "badge bg-success" }
const _hoisted_29 = { class: "row mb-2" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Date de création:")
], -1))
const _hoisted_31 = { class: "col-7" }
const _hoisted_32 = {
  key: 0,
  class: "row mb-2"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Dernière modification:")
], -1))
const _hoisted_34 = { class: "col-7" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-md-12" }
const _hoisted_37 = { class: "text-primary mb-3 border-bottom pb-2" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-book me-2" }, null, -1))
const _hoisted_39 = {
  key: 0,
  class: "cours-container"
}
const _hoisted_40 = { class: "cours-header bg-primary text-white p-2 rounded mb-3" }
const _hoisted_41 = { class: "mb-0" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-book me-2" }, null, -1))
const _hoisted_43 = { class: "row mb-3" }
const _hoisted_44 = { class: "col-md-4" }
const _hoisted_45 = { class: "info-item mb-2" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-muted d-block" }, "Matière", -1))
const _hoisted_47 = { class: "info-item mb-2" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-muted d-block" }, "Filière", -1))
const _hoisted_49 = { class: "col-md-4" }
const _hoisted_50 = { class: "info-item mb-2" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-muted d-block" }, "Niveau", -1))
const _hoisted_52 = { class: "info-item mb-2" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-muted d-block" }, "Professeur", -1))
const _hoisted_54 = { class: "col-md-4" }
const _hoisted_55 = { class: "info-item mb-2" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-muted d-block" }, "Classe", -1))
const _hoisted_57 = { class: "info-item mb-2" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-muted d-block" }, "Mode", -1))
const _hoisted_59 = { class: "creneaux-section border-top pt-3" }
const _hoisted_60 = { class: "text-secondary mb-3" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-clock me-2" }, null, -1))
const _hoisted_62 = { class: "row" }
const _hoisted_63 = { class: "creneau-card border rounded p-2 bg-light" }
const _hoisted_64 = { class: "d-flex align-items-center" }
const _hoisted_65 = { class: "badge bg-primary me-2" }
const _hoisted_66 = { class: "creneau-details flex-grow-1" }
const _hoisted_67 = { class: "fw-bold text-dark" }
const _hoisted_68 = { class: "text-muted small" }
const _hoisted_69 = {
  key: 1,
  class: "alert alert-info"
}
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-info me-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: "/liste-emplois",
              class: "btn btn-primary transition border-0 lh-1 fw-medium"
            }, {
              default: _withCtx(() => [
                _hoisted_6,
                _hoisted_7
              ]),
              _: 1
            }),
            _hoisted_8
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.emploiDuTemps?.typeEmploi?.libelle || 'N/A'), 1)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.emploiDuTemps?.dateDebut ? _ctx.format_date(_ctx.emploiDuTemps.dateDebut) : 'N/A'), 1)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.emploiDuTemps?.dateFin ? _ctx.format_date(_ctx.emploiDuTemps.dateFin) : 'N/A'), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.coursGroupes?.length || 0), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.emploiDuTemps?.createdAt ? _ctx.format_date(_ctx.emploiDuTemps.createdAt) : 'N/A'), 1)
                ]),
                (_ctx.emploiDuTemps?.updatedAt && _ctx.emploiDuTemps?.updatedAt !== _ctx.emploiDuTemps?.createdAt)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _hoisted_33,
                      _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.format_date(_ctx.emploiDuTemps.updatedAt)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("h5", _hoisted_37, [
                _hoisted_38,
                _createTextVNode("Liste des cours (" + _toDisplayString(_ctx.coursGroupes?.length || 0) + ") ", 1)
              ]),
              (_ctx.coursGroupes && _ctx.coursGroupes.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coursGroupes, (coursGroupe, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "cours-card border rounded p-3 mb-3 shadow-sm bg-white"
                      }, [
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("h6", _hoisted_41, [
                            _hoisted_42,
                            _createTextVNode("Cours " + _toDisplayString(index + 1) + " - " + _toDisplayString(coursGroupe.matiere), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("div", _hoisted_45, [
                              _hoisted_46,
                              _createElementVNode("strong", null, _toDisplayString(coursGroupe.matiere), 1)
                            ]),
                            _createElementVNode("div", _hoisted_47, [
                              _hoisted_48,
                              _createElementVNode("strong", null, _toDisplayString(coursGroupe.filiere), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_49, [
                            _createElementVNode("div", _hoisted_50, [
                              _hoisted_51,
                              _createElementVNode("strong", null, _toDisplayString(coursGroupe.niveau), 1)
                            ]),
                            _createElementVNode("div", _hoisted_52, [
                              _hoisted_53,
                              _createElementVNode("strong", null, _toDisplayString(coursGroupe.professeur), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_54, [
                            _createElementVNode("div", _hoisted_55, [
                              _hoisted_56,
                              _createElementVNode("strong", null, _toDisplayString(coursGroupe.classe), 1)
                            ]),
                            _createElementVNode("div", _hoisted_57, [
                              _hoisted_58,
                              _createElementVNode("span", {
                                class: _normalizeClass(coursGroupe.estEnLigne ? 'badge bg-info' : 'badge bg-secondary')
                              }, _toDisplayString(coursGroupe.estEnLigne ? 'En ligne' : 'Présentiel'), 3)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_59, [
                          _createElementVNode("h6", _hoisted_60, [
                            _hoisted_61,
                            _createTextVNode(" Créneaux horaires (" + _toDisplayString(coursGroupe.creneaux.length) + ") ", 1)
                          ]),
                          _createElementVNode("div", _hoisted_62, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(coursGroupe.creneaux, (creneau, creneauIndex) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: creneauIndex,
                                class: "col-md-6 col-lg-4 mb-2"
                              }, [
                                _createElementVNode("div", _hoisted_63, [
                                  _createElementVNode("div", _hoisted_64, [
                                    _createElementVNode("span", _hoisted_65, _toDisplayString(creneauIndex + 1), 1),
                                    _createElementVNode("div", _hoisted_66, [
                                      _createElementVNode("div", _hoisted_67, _toDisplayString(creneau.jour), 1),
                                      _createElementVNode("div", _hoisted_68, _toDisplayString(creneau.heureDebut) + " - " + _toDisplayString(creneau.heureFin), 1)
                                    ])
                                  ])
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_69, [
                    _hoisted_70,
                    _createTextVNode(" Aucun cours trouvé pour cet emploi du temps. ")
                  ]))
            ])
          ])
        ])
      ])
    ])
  ]))
}